<template>
    <div style="z-index:1;width: 650px;height: 90px;border: 1px solid #ccc;border-radius:12px;margin-top:10px;margin-bottom: 30px;padding: 10px;">
        <div style="display: flex;margin-left: 10px;">
            <SymbolView 
            v-for="item in listData.filter(item=>item.index<13)"
            :key="item.id"
            :id="item.id" 
            :text="item.text"
            :status="item.chargeStatus"
            v-show="item.show"/>
        </div>
        <div style="display: flex;margin-left: 10px;">
            <SymbolView 
            v-for="item in listData.filter(item=>item.index>12)"
            :key="item.id"
            :id="item.id" 
            :text="item.text"
            :status="item.chargeStatus"
            v-show="item.show"/>
        <!-- <span v-if="listData.length>16" style="margin-top: auto;margin-bottom: 0px;font-size:12px;color:#5b9bd5">显示更多</span> -->
        </div>
        <!-- <div style="display: flex;margin-left: 20px;">
            <SymbolView 
            v-for="item in listData.filter(item=>item.index>16)"
            :key="item.id"
            :id="item.id" 
            :text="item.text"
            :status="item.chargeStatus"
            v-show="item.show"/>
        </div> -->
        <!-- <svg width="100%" height="300" style="z-index: -1;margin-top: 10px;">
                <line x1="0" y1="0" x2="5000" y2="0" style="stroke:#5b9bd5; stroke-width:1.5px;" stroke-dasharray="3 2"></line>
        </svg> -->
    </div>
</template>

<script>
import SymbolView from './SymbolView.vue';
export default{
    name:'LineDraw',
    components:{
        SymbolView
    },
    data(){
        return{
        }
    },
    created(){
        var i=1;
        this.listData.forEach((item)=>{
            item['index']=i;
            i+=1;
        })
    },
    props:{
        listData:{
            type:Array,
            required:true,
        }
    }
}
</script>